import { render, staticRenderFns } from "./DoctorCenter.vue?vue&type=template&id=ba935a3a&scoped=true"
import script from "./DoctorCenter.vue?vue&type=script&lang=js"
export * from "./DoctorCenter.vue?vue&type=script&lang=js"
import style0 from "./DoctorCenter.vue?vue&type=style&index=0&id=ba935a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba935a3a",
  null
  
)

export default component.exports